import { render, staticRenderFns } from "./DialogObjectif.vue?vue&type=template&id=b4f1df74&"
import script from "./DialogObjectif.vue?vue&type=script&lang=js&"
export * from "./DialogObjectif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports